import React, { useEffect, useState } from 'react';
import Router from 'next/router';
import { connect } from 'react-redux';
import { Box, Popover } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { CheckCircle } from 'phosphor-react';
import style from '../../../../styles/sass/components/SavedSearchPopup.module.scss';
import * as types from '../../../../actions/actionTypes';
import { useScreenSizeHook } from '../../../../hooks/screenSizeHooks';
import { isMobile, isTablet } from '../../../../lib/getDeviceSize';

interface SavedSearchProps {
  dispatch: any;
  savedSearchPopup: boolean;
}

interface SavedSearchPopupSubProps {
  currentComponent?: any;
  savedSearchPopup: boolean;
}

const useStyles = makeStyles(
  createStyles({
    savedSearchPopup: {
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.5)',
      borderRadius: '5px',
      textTransform: 'none',
      textAlign: 'left',
      cursor: 'auto',
      zIndex: 11,
    },
    clickHereText: {
      cursor: 'pointer',
      color: '#463264',
    },
    leftArrow: {
      position: 'fixed',
      left: '82px',
      top: '330px',
      width: 0,
      height: 0,
      borderTop: '8px solid transparent',
      borderRight: '8px solid white',
      borderBottom: '8px solid transparent',
    },
    upArrow: {
      position: 'fixed',
      left: '700px',
      top: '230px',
      width: 0,
      height: 0,
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      borderBottom: '8px solid white',
    },
    upArrowMobile: {
      position: 'fixed',
      left: '375px',
      top: '228px',
      width: 0,
      height: 0,
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      borderBottom: '8px solid white',
    },
  }),
);

const popoverPosition = isMobile()
  ? {
      anchorReference: 'anchorPosition' as const,
      anchorPosition: { top: 235, left: 440 },
      anchorOrigin: {
        vertical: 'center' as const,
        horizontal: 'center' as const,
      },
      transformOrigin: {
        vertical: 'top' as const,
        horizontal: 'left' as const,
      },
    }
  : isTablet()
  ? {
      anchorReference: 'anchorPosition' as const,
      anchorPosition: { top: 235, left: 440 },
      anchorOrigin: {
        vertical: 'center' as const,
        horizontal: 'center' as const,
      },
      transformOrigin: {
        vertical: 'top' as const,
        horizontal: 'left' as const,
      },
    }
  : {
      anchorReference: 'anchorPosition' as const,
      anchorPosition: { top: 315, left: 90 },
      anchorOrigin: {
        vertical: 'center' as const,
        horizontal: 'center' as const,
      },
      transformOrigin: {
        vertical: 'top' as const,
        horizontal: 'left' as const,
      },
    };

const SavedSearchPopupSub: React.FC<SavedSearchPopupSubProps> = ({
  currentComponent = null,
  savedSearchPopup,
}) => {
  const classes = useStyles();
  const { mobileView, tabletView } = useScreenSizeHook();
  const [anchorElement, setAnchor] = useState(currentComponent);

  return (
    <Popover
      className={style.popover_class}
      anchorEl={anchorElement}
      open={savedSearchPopup}
      onClose={(e: any) => {
        e.stopPropagation();
        setAnchor(null);
      }}
      {...popoverPosition}
    >
      {!mobileView && !tabletView && <div className={classes.leftArrow} />}
      {tabletView && !mobileView && <div className={classes.upArrow} />}
      {!tabletView && mobileView && <div className={classes.upArrowMobile} />}
      <div className={style.mainBox}>
        <Box
          fontWeight="bold"
          display="flex"
          alignItems="center"
          fontSize="18px"
        >
          <CheckCircle size={22} color="#463264" weight="duotone" />
          <Box ml={1}>You saved a search!</Box>
        </Box>
        <Box>
          <span
            className={classes.clickHereText}
            onClick={() => {
              Router.push('/saved-searches');
            }}
          >
            Click <u>here</u>
          </span>{' '}
          to see your saved searches
        </Box>
      </div>
    </Popover>
  );
};

export const SavedSearchPopup: React.FC<SavedSearchProps> = ({
  savedSearchPopup,
  dispatch,
}) => {
  const { mobileView } = useScreenSizeHook();

  useEffect(() => {
    let timeOutId: any;

    if (savedSearchPopup) {
      timeOutId = setTimeout(() => {
        dispatch({ type: types.CloseSavedSearchPopup });
      }, 3000);
    }

    return () => {
      timeOutId && clearTimeout(timeOutId);
    };
  }, [dispatch, savedSearchPopup]);

  if (!savedSearchPopup) {
    return null;
  }

  if (mobileView) {
    return (
      <Box display="flex" justifyContent="center">
        <SavedSearchPopupSub savedSearchPopup />
      </Box>
    );
  }

  return <SavedSearchPopupSub savedSearchPopup />;
};

const mapStateToProps = (state: any) => ({
  savedSearchPopup: state.dialogs.savedSearchPopup,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(SavedSearchPopup);
